/**
 * @generated SignedSource<<33afc7cfb82aab1b22a97cf52b96da7b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NumberTaskUnit = "CURRENCY" | "CUSTOM";
export type RecurrenceFrequency = "DAILY" | "MONTHLY" | "WEEKLY" | "YEARLY";
export type RoutineNotificationStrategy = "DISABLED" | "STANDARD";
export type RoutineScheduleType = "DAILY" | "MONTHLY" | "WEEKLY";
export type TaskImportance = "OPTIONAL" | "REQUIRED";
export type TaskSentiment = "NEGATIVE" | "NEUTRAL" | "POSITIVE";
export type UpdateRoutineInput = {
  addDescriptionFileIds?: ReadonlyArray<string> | null;
  addDescriptionImageIds?: ReadonlyArray<string> | null;
  addDescriptionMediaIds?: ReadonlyArray<string> | null;
  addDescriptionVideoIds?: ReadonlyArray<string> | null;
  assignedRoleIds?: ReadonlyArray<string> | null;
  createConnections?: ReadonlyArray<AddConnection> | null;
  createSections?: ReadonlyArray<UpdateRoutineCreateSectionInput> | null;
  createTasks?: ReadonlyArray<CreateTaskInput> | null;
  deleteSections?: ReadonlyArray<RemoveSection> | null;
  removeConnections?: ReadonlyArray<RemoveTaskConnection> | null;
  removeDescriptionFileIds?: ReadonlyArray<string> | null;
  removeDescriptionImageIds?: ReadonlyArray<string> | null;
  removeDescriptionMediaIds?: ReadonlyArray<string> | null;
  removeDescriptionVideoIds?: ReadonlyArray<string> | null;
  setDescription?: string | null;
  setNotificationStrategy?: RoutineNotificationStrategy | null;
  setOrgTopicId?: string | null;
  setSchedule?: ScheduleInput | null;
  setSectionOrder?: ReadonlyArray<string> | null;
  setTeamId?: string | null;
  setTitle?: string | null;
  updateSchedule?: RoutineScheduleInput | null;
  updateSections?: ReadonlyArray<UpdateSectionInput> | null;
  updateTasks?: ReadonlyArray<UpdateRoutineUpdateTaskInput> | null;
};
export type AddConnection = {
  check?: CreateTaskSectionConnetion | null;
  number?: CreateTaskNumberExistingSectionConnetion | null;
  text?: CreateTaskSectionConnetion | null;
};
export type CreateTaskSectionConnetion = {
  canBeDisabled?: boolean | null;
  sectionId: string;
  taskId: string;
  topicId?: string | null;
};
export type CreateTaskNumberExistingSectionConnetion = {
  canBeDisabled?: boolean | null;
  greaterThan?: number | null;
  lessThan?: number | null;
  sectionId: string;
  taskId: string;
  topicId?: string | null;
};
export type UpdateRoutineCreateSectionInput = {
  canBeDisabled?: boolean | null;
  id: string;
  orgTopicId?: string | null;
  teamId?: string | null;
  title?: string | null;
};
export type CreateTaskInput = {
  check?: CreateTaskCheckInput | null;
  number?: CreateTaskNumberInput | null;
  text?: CreateTaskTextInput | null;
};
export type CreateTaskCheckInput = {
  id: string;
  imageIds?: ReadonlyArray<string> | null;
  instructions?: string | null;
  sentiments?: ReadonlyArray<TaskSentiment> | null;
  title?: string;
};
export type CreateTaskNumberInput = {
  id: string;
  imageIds?: ReadonlyArray<string> | null;
  instructions?: string | null;
  suffix?: string | null;
  title: string;
  unit?: NumberTaskUnit | null;
};
export type CreateTaskTextInput = {
  id: string;
  imageIds?: ReadonlyArray<string> | null;
  instructions?: string | null;
  title?: string;
};
export type RemoveSection = {
  sectionId: string;
};
export type RemoveTaskConnection = {
  sectionId: string;
  taskId: string;
};
export type ScheduleInput = {
  rules: ReadonlyArray<RecurrenceRuleInput>;
  type?: RoutineScheduleType | null;
  tzid?: string | null;
};
export type RecurrenceRuleInput = {
  byhour?: ReadonlyArray<number> | null;
  byminute?: ReadonlyArray<number> | null;
  bymonth?: ReadonlyArray<number> | null;
  bymonthday?: ReadonlyArray<number> | null;
  bysecond?: ReadonlyArray<number> | null;
  byweekday?: ReadonlyArray<number> | null;
  byweekno?: ReadonlyArray<number> | null;
  byyearday?: ReadonlyArray<number> | null;
  dtstart?: string | null;
  duration?: number | null;
  freq: RecurrenceFrequency;
  interval?: number | null;
  isAllDay?: boolean | null;
  tasks: ReadonlyArray<RecurrenceRuleTaskDescriptionInput>;
  until?: string | null;
  wkst?: number | null;
};
export type RecurrenceRuleTaskDescriptionInput = {
  importance: TaskImportance;
  taskId: string;
};
export type RoutineScheduleInput = {
  daily?: RoutineScheduleDailyInput | null;
  monthly?: RoutineScheduleMonthlyInput | null;
  weekly?: RoutineScheduleWeeklyInput | null;
};
export type RoutineScheduleDailyInput = {
  deadlineDuration?: number | null;
  isAllDay?: boolean | null;
  weekdays: ReadonlyArray<RoutineScheduleDailyWeekdayInput>;
};
export type RoutineScheduleDailyWeekdayInput = {
  startTime?: TimeInput | null;
  tasks: ReadonlyArray<RoutineScheduleTaskImportanceInput>;
  weekday: number;
};
export type TimeInput = {
  hour: number;
  minute: number;
};
export type RoutineScheduleTaskImportanceInput = {
  importance: TaskImportance;
  taskId: string;
};
export type RoutineScheduleMonthlyInput = {
  endDay?: number | null;
  months: ReadonlyArray<number>;
  startDay: number;
};
export type RoutineScheduleWeeklyInput = {
  endWeekday?: number | null;
  startTime?: TimeInput | null;
  startWeekday?: number | null;
  weeks?: ReadonlyArray<number> | null;
};
export type UpdateSectionInput = {
  sectionId: string;
  setCanBeDisabled?: boolean | null;
  setOrgTopicId?: string | null;
  setTaskOrder?: ReadonlyArray<string> | null;
  setTeamId?: string | null;
  setTitle?: string | null;
  unsetOrgTopicId?: boolean | null;
  unsetTeamId?: boolean | null;
};
export type UpdateRoutineUpdateTaskInput = {
  check?: UpdateTaskCheckInput | null;
  number?: UpdateTaskNumberInput | null;
  taskId: string;
  text?: UpdateTaskTextInput | null;
};
export type UpdateTaskCheckInput = {
  setImageIds?: ReadonlyArray<string> | null;
  setInstructions?: string | null;
  setSentiments?: ReadonlyArray<TaskSentiment> | null;
  setTitle?: string | null;
};
export type UpdateTaskNumberInput = {
  setImageIds?: ReadonlyArray<string> | null;
  setInstructions?: string | null;
  setTitle?: string | null;
  setUnit?: NumberTaskUnit | null;
};
export type UpdateTaskTextInput = {
  setImageIds?: ReadonlyArray<string> | null;
  setInstructions?: string | null;
  setTitle?: string | null;
};
export type useSaveRoutineEditMutation$variables = {
  id: string;
  input: UpdateRoutineInput;
};
export type useSaveRoutineEditMutation$data = {
  readonly routine: {
    readonly update: {
      readonly routine: {
        readonly " $fragmentSpreads": FragmentRefs<"RoutineEditMainRoutine_Routine">;
      } | null;
    } | null;
  } | null;
};
export type useSaveRoutineEditMutation = {
  response: useSaveRoutineEditMutation$data;
  variables: useSaveRoutineEditMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v6 = [
  (v3/*: any*/)
],
v7 = {
  "alias": null,
  "args": null,
  "concreteType": "OrgTopic",
  "kind": "LinkedField",
  "name": "orgTopic",
  "plural": false,
  "selections": (v6/*: any*/),
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "taskId",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isPrivate",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "width",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "height",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useSaveRoutineEditMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "RoutineMutation",
        "kind": "LinkedField",
        "name": "routine",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v2/*: any*/),
            "concreteType": "UpdateRoutinePayload",
            "kind": "LinkedField",
            "name": "update",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Routine",
                "kind": "LinkedField",
                "name": "routine",
                "plural": false,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "RoutineEditMainRoutine_Routine"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useSaveRoutineEditMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "RoutineMutation",
        "kind": "LinkedField",
        "name": "routine",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v2/*: any*/),
            "concreteType": "UpdateRoutinePayload",
            "kind": "LinkedField",
            "name": "update",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Routine",
                "kind": "LinkedField",
                "name": "routine",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "canBeUnarchived",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isArchived",
                    "storageKey": null
                  },
                  (v4/*: any*/),
                  (v5/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isOrg",
                    "storageKey": null
                  },
                  (v7/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "canBeConvertedToWorkspaceTemplate",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "RoutineVersion",
                    "kind": "LinkedField",
                    "name": "activeVersion",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TaskSectionConnection",
                        "kind": "LinkedField",
                        "name": "connections",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "sectionId",
                            "storageKey": null
                          },
                          (v8/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "ordinal",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "canBeDisabled",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "OrgTopic",
                            "kind": "LinkedField",
                            "name": "orgTopic",
                            "plural": false,
                            "selections": [
                              (v3/*: any*/),
                              (v9/*: any*/),
                              (v10/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v3/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "tasks",
                        "plural": true,
                        "selections": [
                          (v3/*: any*/),
                          (v4/*: any*/),
                          (v11/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "sentiments",
                                "storageKey": null
                              }
                            ],
                            "type": "TaskCheck",
                            "abstractKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "instructions",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Image",
                            "kind": "LinkedField",
                            "name": "images",
                            "plural": true,
                            "selections": [
                              (v3/*: any*/),
                              {
                                "alias": null,
                                "args": [
                                  {
                                    "kind": "Literal",
                                    "name": "minHeight",
                                    "value": 700
                                  },
                                  {
                                    "kind": "Literal",
                                    "name": "minWidth",
                                    "value": 700
                                  }
                                ],
                                "concreteType": "ImageSize",
                                "kind": "LinkedField",
                                "name": "size",
                                "plural": false,
                                "selections": [
                                  (v3/*: any*/),
                                  (v12/*: any*/),
                                  (v13/*: any*/),
                                  (v14/*: any*/)
                                ],
                                "storageKey": "size(minHeight:700,minWidth:700)"
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "TaskNumberGoals",
                                "kind": "LinkedField",
                                "name": "goals",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "greaterThan",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "lessThan",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "RoutineSection",
                                    "kind": "LinkedField",
                                    "name": "section",
                                    "plural": false,
                                    "selections": (v6/*: any*/),
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "unit",
                                "storageKey": null
                              }
                            ],
                            "type": "TaskNumber",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "RoutineSectionVersion",
                        "kind": "LinkedField",
                        "name": "sections",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "RoutineSection",
                            "kind": "LinkedField",
                            "name": "section",
                            "plural": false,
                            "selections": [
                              (v3/*: any*/),
                              (v4/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Team",
                                "kind": "LinkedField",
                                "name": "assignedTeam",
                                "plural": false,
                                "selections": (v6/*: any*/),
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v3/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "orgCanBeDisabled",
                            "storageKey": null
                          },
                          (v7/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "description",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "File",
                    "kind": "LinkedField",
                    "name": "descriptionFiles",
                    "plural": true,
                    "selections": [
                      (v3/*: any*/),
                      (v5/*: any*/),
                      (v9/*: any*/),
                      (v12/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Image",
                    "kind": "LinkedField",
                    "name": "descriptionImages",
                    "plural": true,
                    "selections": [
                      (v3/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "thumbhash",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ImageSize",
                        "kind": "LinkedField",
                        "name": "sizes",
                        "plural": true,
                        "selections": [
                          (v3/*: any*/),
                          (v12/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "urlExpiresAt",
                            "storageKey": null
                          },
                          (v14/*: any*/),
                          (v13/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "currentSchedule",
                    "plural": false,
                    "selections": [
                      (v11/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "deadlineDuration",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isAllDay",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "hasAdvancedScheduling",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "RoutineScheduleDailyWeekday",
                            "kind": "LinkedField",
                            "name": "weekdays",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "weekday",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Time",
                                "kind": "LinkedField",
                                "name": "startTime",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "hour",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "minute",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "RoutineScheduleTaskImportance",
                                "kind": "LinkedField",
                                "name": "tasks",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "importance",
                                    "storageKey": null
                                  },
                                  (v8/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "type": "RoutineScheduleDaily",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "startWeekday",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "endWeekday",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "weeks",
                            "storageKey": null
                          }
                        ],
                        "type": "RoutineScheduleWeekly",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "startDay",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "endDay",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "months",
                            "storageKey": null
                          }
                        ],
                        "type": "RoutineScheduleMonthly",
                        "abstractKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Team",
                    "kind": "LinkedField",
                    "name": "ownerTeam",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      (v9/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "color",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "icon",
                        "storageKey": null
                      },
                      (v10/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Video",
                    "kind": "LinkedField",
                    "name": "descriptionVideos",
                    "plural": true,
                    "selections": (v6/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AssignedRole",
                    "kind": "LinkedField",
                    "name": "assignedRoles",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "EmployeeRole",
                        "kind": "LinkedField",
                        "name": "role",
                        "plural": false,
                        "selections": (v6/*: any*/),
                        "storageKey": null
                      },
                      (v3/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "canBeConvertedToWeekly",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "0dd70190cbacf5aa31fd1f1f635842ce",
    "id": null,
    "metadata": {},
    "name": "useSaveRoutineEditMutation",
    "operationKind": "mutation",
    "text": "mutation useSaveRoutineEditMutation(\n  $id: ID!\n  $input: UpdateRoutineInput!\n) {\n  routine(id: $id) {\n    update(input: $input) {\n      routine {\n        ...RoutineEditMainRoutine_Routine\n        id\n      }\n    }\n  }\n}\n\nfragment Image_image on Image {\n  id\n  thumbhash\n  sizes {\n    id\n    url\n    urlExpiresAt\n    height\n    width\n  }\n}\n\nfragment RoutineEditAssignedRolesListItem_Routine on Routine {\n  isOrg\n  ownerTeam {\n    id\n  }\n}\n\nfragment RoutineEditContentCard_Routine on Routine {\n  id\n  title\n  type\n  description\n  descriptionFiles {\n    id\n    type\n    name\n    url\n  }\n  descriptionImages {\n    id\n    ...Image_image\n    sizes {\n      height\n      width\n      url\n      id\n    }\n  }\n}\n\nfragment RoutineEditMainRoutine_Routine on Routine {\n  id\n  canBeUnarchived\n  isArchived\n  title\n  type\n  isOrg\n  orgTopic {\n    id\n  }\n  canBeConvertedToWorkspaceTemplate\n  ...useIsSaveable_Routine\n  ...RoutineEditContentCard_Routine\n  ...RoutineEditScheduleCard_Routine\n  ...RoutineEditTeamListItem_Routine\n  ...useSaveRoutineEdit_routine\n  ...useRoutineEditDirty_Routine\n  ...RoutineEditAssignedRolesListItem_Routine\n  canBeConvertedToWeekly\n  currentSchedule {\n    __typename\n  }\n}\n\nfragment RoutineEditScheduleCard_Routine on Routine {\n  id\n  title\n  type\n  activeVersion {\n    tasks {\n      id\n      title\n      __typename\n      ... on TaskCheck {\n        sentiments\n      }\n    }\n    id\n  }\n  currentSchedule {\n    __typename\n    ... on RoutineScheduleDaily {\n      deadlineDuration\n      isAllDay\n      hasAdvancedScheduling\n      weekdays {\n        weekday\n        startTime {\n          hour\n          minute\n        }\n        tasks {\n          importance\n          taskId\n        }\n      }\n    }\n    ... on RoutineScheduleWeekly {\n      startWeekday\n      endWeekday\n      weeks\n    }\n    ... on RoutineScheduleMonthly {\n      startDay\n      endDay\n      months\n    }\n  }\n}\n\nfragment RoutineEditTeamListItem_Routine on Routine {\n  title\n  ownerTeam {\n    id\n    name\n    color\n    icon\n    isPrivate\n  }\n}\n\nfragment useIsSaveable_Routine on Routine {\n  isOrg\n  activeVersion {\n    connections {\n      sectionId\n      taskId\n    }\n    id\n  }\n}\n\nfragment useRoutineEditDirty_Routine on Routine {\n  title\n  description\n  ownerTeam {\n    id\n  }\n  assignedRoles {\n    role {\n      id\n    }\n    id\n  }\n  activeVersion {\n    tasks {\n      id\n      title\n      instructions\n      images {\n        id\n        size(minHeight: 700, minWidth: 700) {\n          id\n          url\n          width\n          height\n        }\n      }\n      __typename\n      ... on TaskCheck {\n        sentiments\n      }\n      ... on TaskNumber {\n        goals {\n          greaterThan\n          lessThan\n          section {\n            id\n          }\n        }\n        unit\n      }\n    }\n    connections {\n      taskId\n      sectionId\n      ordinal\n      canBeDisabled\n      orgTopic {\n        id\n        name\n        isPrivate\n      }\n    }\n    sections {\n      orgCanBeDisabled\n      orgTopic {\n        id\n      }\n      section {\n        id\n        title\n        assignedTeam {\n          id\n        }\n      }\n      id\n    }\n    id\n  }\n  currentSchedule {\n    __typename\n    ... on RoutineScheduleDaily {\n      deadlineDuration\n      isAllDay\n      weekdays {\n        startTime {\n          hour\n          minute\n        }\n        weekday\n        tasks {\n          importance\n          taskId\n        }\n      }\n    }\n    ... on RoutineScheduleWeekly {\n      startWeekday\n      endWeekday\n      weeks\n    }\n    ... on RoutineScheduleMonthly {\n      months\n      startDay\n      endDay\n    }\n  }\n}\n\nfragment useSaveRoutineEdit_routine on Routine {\n  id\n  title\n  description\n  descriptionFiles {\n    id\n  }\n  descriptionVideos {\n    id\n  }\n  ownerTeam {\n    id\n  }\n  assignedRoles {\n    role {\n      id\n    }\n    id\n  }\n  currentSchedule {\n    __typename\n    ... on RoutineScheduleDaily {\n      hasAdvancedScheduling\n    }\n  }\n  activeVersion {\n    tasks {\n      id\n      title\n      __typename\n      ... on TaskCheck {\n        sentiments\n      }\n    }\n    sections {\n      section {\n        id\n      }\n      id\n    }\n    connections {\n      sectionId\n      taskId\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "5a0e9f25388c5868801b56596da06d41";

export default node;
